/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.session.SessionSearchScope
*/
export var SessionSearchScope;
(function (SessionSearchScope) {
    SessionSearchScope["METADATA"] = "METADATA";
    SessionSearchScope["CONTENT"] = "CONTENT";
    SessionSearchScope["BOTH"] = "BOTH";
})(SessionSearchScope || (SessionSearchScope = {}));
//# sourceMappingURL=SessionSearchScope.js.map